export default "__VITE_ASSET__mhVijS29__";